<div class="tw-flex tw-justify-center tw-items-center tw-min-h-[60vh]">
  <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
    <!-- Progress bar -->
    <div class="tw-w-64" attr.aria-label="{{ 'loadingProgress' | i18n }}">
      <bit-progress-bar [value]="stepConfig[progressStep()].progress" [hideStartHint]="true" />
    </div>

    <!-- Status message -->
    <span class="tw-text-main tw-text-base tw-font-medium tw-leading-4">
      {{ stepConfig[progressStep()].message | i18n }}
    </span>
  </div>
</div>
